import React from 'react';
import { Box, Typography } from '@mui/material';

// TODO location will be added later with Translations
const DisclaimerNotice = ({ doctorName, clinicName, location }) => {
    if (!doctorName || !clinicName) return null;

    return (
        <Box sx={{ mt: 2, mb: 1, px: 2 }}>
            <Typography variant="caption" color="textSecondary">
                Cetra is not liable for the content provided in this handout. The content and/or illustrations have been
                edited by {doctorName} of {clinicName}.
            </Typography>
        </Box>
    );
};

export default DisclaimerNotice;
